var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 81,
    viewBox: "0 0 198 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5776 15.5208V65.4894H63.6905V15.5208H13.5776ZM12.0234 13.9711H65.2446V67.039H12.0137V13.9614L12.0234 13.9711Z",
    fill: "#0D0B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9459 2.84375L1.18066 40.5001L38.9459 78.1564L76.7109 40.5001L38.9459 2.84375Z",
    fill: "url(#paint0_linear_338_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9459 2.84375L1.18066 40.5001L38.9459 78.1564L76.7109 40.5001L38.9459 2.84375Z",
    fill: "url(#paint1_linear_338_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.428 37.0745C152.31 37.0745 148.141 32.9207 148.141 27.9174C148.141 22.7882 152.31 18.7603 157.428 18.7603C162.545 18.7603 166.715 22.7882 166.715 27.9174C166.715 32.9207 162.545 37.0745 157.428 37.0745ZM157.428 33.3613C160.397 33.3613 162.798 31.1586 162.798 27.9174C162.798 24.5503 160.397 22.4734 157.428 22.4734C154.49 22.4734 152.121 24.5503 152.121 27.9174C152.121 31.1586 154.49 33.3613 157.428 33.3613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.712 36.6024V14.1973H134.693V25.6517H137.062L141.074 19.1378H145.37L141.263 25.6517H145.875V36.6024H141.926V29.3648H134.693V36.6024H130.712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.497 16.4001C123.233 16.4001 122.191 15.3617 122.191 14.103C122.191 12.8443 123.233 11.8374 124.497 11.8374C125.76 11.8374 126.771 12.8443 126.771 14.103C126.771 15.3617 125.76 16.4001 124.497 16.4001ZM122.507 36.571V19.2009H126.487V36.571H122.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.357 41.5746V19.2012H104.243V22.7254H104.369C105.443 20.3024 108.16 18.729 111.161 18.729C115.899 18.729 119.564 22.82 119.564 27.9176C119.564 33.0155 115.899 37.1063 111.161 37.1063C108.286 37.1063 105.98 35.8789 104.464 33.2673H104.338V41.5746H100.357ZM110.118 33.3931C113.056 33.3931 115.488 31.2532 115.488 27.9176C115.488 24.5821 113.056 22.4424 110.118 22.4424C107.212 22.4424 104.812 24.5821 104.812 27.9176C104.812 31.2532 107.212 33.3931 110.118 33.3931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5088 36.6026V14.292H96.8185V17.9421H86.4575V23.575H94.9865V27.2566H86.4575V32.9208H96.8185V36.6026H82.5088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.822 67.3624V53.6426H186.137V49.9607H188.822V45.0518H192.771V49.9607H195.551V53.6426H192.771V63.6808H195.456V67.3624H188.822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.757 67.8345C170.419 67.8345 166.249 63.6807 166.249 58.5831C166.249 53.4852 170.419 49.4888 175.757 49.4888C181.096 49.4888 185.266 53.4852 185.266 58.7089C185.266 58.992 185.234 59.4956 185.139 59.9676H170.482C170.924 62.359 173.167 64.1527 175.82 64.1527C177.905 64.1527 179.643 63.1773 180.464 61.4151H184.823C183.591 65.1598 180.117 67.8345 175.757 67.8345ZM170.545 56.9781H180.875C180.527 54.9012 178.474 53.1706 175.694 53.1706C172.914 53.1706 170.829 54.7753 170.545 56.9781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.821 67.362V44.957H152.801V56.4112H155.17L159.182 49.8975H163.478L159.371 56.4112H163.983V67.362H160.035V60.1246H152.801V67.362H148.821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.957 67.3621V49.9604H146.476V53.6423H139.937V67.3621H135.957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.104 67.8343C116.144 67.8343 112.48 63.7435 112.48 58.6457C112.48 53.548 116.144 49.457 121.104 49.457C124.199 49.457 126.6 51.1248 127.706 53.4221H127.832V49.9605H131.686V67.3621H127.832V63.9638H127.706C126.19 66.7015 123.915 67.8343 121.104 67.8343ZM121.925 64.1211C125.084 64.1211 127.263 61.761 127.263 58.6457C127.263 55.4988 125.084 53.1704 121.925 53.1704C118.798 53.1704 116.65 55.4988 116.65 58.6457C116.65 61.761 118.798 64.1211 121.925 64.1211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.612 49.9604V67.3621H105.695V53.6423H97.7347V67.3621H93.8176V53.6423H85.8888V67.3621H81.9717V49.9604H109.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 31.0494L38.9683 25.563L34.1226 31.0494L38.9683 33.8351L43.75 31.0494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9685 36.6036L50.9497 29.6958L48.6084 39.3064L55.7845 35.195L51.7789 51.3627L44.5621 55.4372L48.6084 39.3064L38.9685 44.8379L29.3361 39.3167L33.3301 55.4372L26.2036 51.3627L22.1074 35.1962L29.3361 39.3167L26.929 29.6406L38.9685 36.6036Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_338_334",
    x1: 1.18066,
    y1: 40.5001,
    x2: 76.6373,
    y2: 40.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "#EE8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#38DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_338_334",
    x1: 1.18066,
    y1: 40.5001,
    x2: 76.6373,
    y2: 40.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "#EE8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#38DEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.47e3ce67860fd2d67bcdb22b5276f440.svg";
export { ForwardRef as ReactComponent };